import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Checkout, OfferPage, CongratsScreen, AuthForm } from "pages";
import ViralAgencyCourse from './pages/OfferPage/ViralAgencyCourse';
import VerifyEmail from './pages/VerifyEmail';

// PrivateRoute for course video access
const PrivateCourseRoute = ({ children }: { children: React.ReactNode }) => {
  const userData = localStorage.getItem('user');
  let status = '';
  if (userData) {
    try {
      const user = JSON.parse(userData);
      status = user.status;
    } catch {}
  }
  if (status === 'succeeded') {
    return children;
  } else {
    return <Navigate to="/" replace />;
  }
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<OfferPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/login-signup" element={<AuthForm />} />
        <Route path="/congrats" element={<CongratsScreen />} />
        <Route path="/course-video" element={
          <PrivateCourseRoute>
            <ViralAgencyCourse />
          </PrivateCourseRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App; 